<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Star products'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Star products'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                { value: 'description', width: '150px' },
                { value: 'stars', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'starProducts/index',
            deleteItem: 'starProducts/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/star-products/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/star-products/add');
        }
    }
};
</script>
